export const actionButtonsContainerStyles = {
    display: "flex", 
    gap: 2, 
    justifyContent: 'space-between', 
    width: '100%', 
    marginBottom: '20px'
};

export const actionButtonsGroupStyles = {
    display: 'flex', 
    gap: 2, 
    marginLeft: 'auto'
};

export const filterButtonStyles = {
    backgroundColor: '#6C5DD3',
    '&:hover': {
        backgroundColor: '#5a4eb8'
    },
    textTransform: 'uppercase',
    fontSize: '13px',
    fontWeight: 500,
    padding: '6px 16px',
    minWidth: '120px'
};
